import client from "../api-client";
import toQueryString from "../toQueryString";

const URL = "product.php";
const SUBSCRIPTIONS_URL = "user_subscriptions.php";

const RESTORE_URL = "product_restore.php";
const REFRESH_URL = "product_refresh.php";
const TERMINATE_URL = "product_terminate.php";

export const concurrentConnections = [
  { value: "5", label: "Limited to 5 concurrent connections" },
  { value: "yes", label: "Limited to 50 concurrent connections" },
  { value: "no", label: "Limited to 500 concurrent connections" },
];

export const contracts = [
  { value: "Trial", label: "Trial" },
  { value: "30 days", label: "30 days" },
  { value: "90 Days", label: "90 Days" },
  { value: "180 days", label: "180 days" },
  { value: "360 days", label: "360 days" },
];

export const productTypes = [
  {
    name: "Premium",
    key: "Premium",
    color: "#70bbfd",
    checked: false,
  },
  {
    name: "Private",
    key: "Private",
    color: "#4ce1b6",
    checked: false,
  },
];

export const statuses = [
  {
    name: "Active",
    key: "Active",
    color: "#4ce1b6",
    checked: false,
  },
  {
    name: "Inactive",
    key: "Inactive",
    color: "#ff4861",
    checked: false,
  },
  {
    name: "Cancellation Request",
    key: "terminate_pending",
    color: "#f6da6e",
    checked: false,
  },
  {
    name: "Refresh Request",
    key: "refresh_pending",
    color: "#70bbfd",
    checked: false,
  },
];

export const getValidDays = [
  {
    value: 1,
    label: "1 Day",
  },
  {
    value: 2,
    label: "2 Days",
  },
  {
    value: 3,
    label: "3 Days",
  },
  {
    value: 7,
    label: "7 Days",
  },
  {
    value: 15,
    label: "15 Days",
  },
  {
    value: 30,
    label: "30 Days",
  },
  {
    value: 60,
    label: "60 Days",
  },
  {
    value: 90,
    label: "90 Days",
  },
  {
    value: 180,
    label: "180 Days",
  },
  {
    value: 365,
    label: "1 Year",
  },
];

export const terminate = async (id) => {
  let params = toQueryString({ pid: id });
  const response = await client(URL + `?${params}`, {
    method: "DELETE",
  });
  return await await response;
};

export const updateProxies = async (id, uid, proxies) => {
  let params = toQueryString({ pid: id, uid: uid });
  const response = await client(URL + `?${params}`, {
    method: "POST",
    body: proxies,
  });
  return await await response;
};

export const get = async (filters) => {
  if (filters.getTotal !== undefined) {
    delete filters.getTotal;
  }

  let params = toQueryString(filters);

  const response = await client(SUBSCRIPTIONS_URL + `?${params}`);
  return await await response;
};

export const getTotal = async (filters) => {
  filters["getTotal"] = true;

  let params = toQueryString(filters);

  const response = await client(SUBSCRIPTIONS_URL + `?${params}`);
  return await await response;
};

export const repurchase = async (pid) => {
  let params = toQueryString({ pid: pid });
  return await client(RESTORE_URL + `?${params}`, { method: "PUT" });
};

export const approveRefresh = async (pid) => {
  let params = toQueryString({ pid: pid });
  return await client(REFRESH_URL + `?${params}`, { method: "POST" });
};

export const rejectRefresh = async (pid) => {
  let params = toQueryString({ pid: pid });
  return await client(REFRESH_URL + `?${params}`, { method: "DELETE" });
};

export const approveTerminate = async (pid) => {
  let params = toQueryString({ pid: pid });
  return await client(TERMINATE_URL + `?${params}`, { method: "POST" });
};

export const rejectTerminate = async (pid) => {
  let params = toQueryString({ pid: pid });
  return await client(TERMINATE_URL + `?${params}`, { method: "DELETE" });
};

export const getOrderInfo = async (oid) => {
  let filters = [];
  filters["table"] = "orders";
  filters["filters"] = [];
  filters["filters"]["oid"] = oid;

  let params = toQueryString(filters);

  const response = await client(`get.php?${params}`);
  return await await response;
};
